import { SmartTable } from '../../../../components/smart-table/smart-table.model';

export class Controller {

    /** @ngInject */
    constructor($window) {
        this.$window = $window;
    }

    $onInit() {
        this.st = new SmartTable();
    }

    viewInvoice(url) {
        this.$window.open(url, '_blank');
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/activities/license-activities.controller.js